import { ObjectiveStateResourceType } from '../resources/ObjectiveState';

// TODO: Live Action Short Film 2026 — both "The Singers" and "Two People
// Exchanging Saliva" should be treated as correct for this category.
let LIVE_ACTION_SHORT_EQUIVALENT_NOMINEES = new Set([
  'iTZ1eyNVdCrdPfyR2fpoh', // The Singers
  'rLEc89MBBOh2EGXj-dKwG', // Two People Exchanging Saliva
]);

export let getScoreMap = {
  winner: ({
    results,
    data,
  }: {
    results: ObjectiveStateResourceType['results'];
    data: {
      categoryKey: string;
      nomineeId: string;
      points: number;
    };
  }) => {
    let winnerNomineeId = Object.values(
      results.find(item => Object.keys(item)[0] === data.categoryKey) || {},
    )[0];
    if (winnerNomineeId === data.nomineeId) return data.points;
    // TODO: remove this override after 2026 ceremony
    if (
      LIVE_ACTION_SHORT_EQUIVALENT_NOMINEES.has(winnerNomineeId as string) &&
      LIVE_ACTION_SHORT_EQUIVALENT_NOMINEES.has(data.nomineeId)
    )
      return data.points;
    if (winnerNomineeId) return 0;
  },
  eventBoolean: ({
    events,
    data,
  }: {
    events: ObjectiveStateResourceType['events'];
    data: {
      eventName: keyof typeof events;
      points: number;
    };
  }) => {
    if (events[data.eventName]) return data.points || undefined;
  },
  eventCount: ({
    events,
    data,
  }: {
    data: {
      eventName: keyof typeof events;
      points: number;
    };
    events: ObjectiveStateResourceType['events'];
  }) => {
    let count = (events[data.eventName] || 0) as number;
    return count * data.points || undefined;
  },
  pass: ({
    results,
    data,
  }: {
    results: ObjectiveStateResourceType['results'];
    data: {
      points: number;
      categoryKey: string;
    };
  }) => {
    if (results.some(item => Object.keys(item)[0] === data.categoryKey))
      return data.points;
  },
} as const;
